<template>
  <div class="skill-item">
    <div class="flex items-center justify-between mb-2">
      <div class="flex items-center space-x-3">
        <div class="w-6 h-6 flex items-center justify-center">
          <img 
            v-if="image && showImage" 
            :src="image" 
            :alt="name"
            class="w-6 h-6 object-contain"
            @error="onImageError"
          />
          <span v-else class="text-lg">{{ icon }}</span>
        </div>
        <span class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ name }}</span>
      </div>
      <span class="text-xs text-gray-500 dark:text-gray-400">{{ level }}%</span>
    </div>
    <div class="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
      <div
        class="h-2 rounded-full transition-all duration-1000 ease-out"
        :class="progressBarClass"
        :style="{ width: animatedLevel + '%' }"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'

const props = defineProps({
  name: String,
  level: Number,
  icon: String,
  image: String,
  color: String
})

const animatedLevel = ref(0)
const showImage = ref(true)

const progressBarClass = computed(() => {
  const colorClasses = {
    green: 'bg-green-500 dark:bg-green-400',
    blue: 'bg-blue-500 dark:bg-blue-400',
    yellow: 'bg-yellow-500 dark:bg-yellow-400',
    orange: 'bg-orange-500 dark:bg-orange-400',
    purple: 'bg-purple-500 dark:bg-purple-400',
    red: 'bg-red-500 dark:bg-red-400',
    pink: 'bg-pink-500 dark:bg-pink-400',
    indigo: 'bg-indigo-500 dark:bg-indigo-400',
    cyan: 'bg-cyan-500 dark:bg-cyan-400',
    gray: 'bg-gray-500 dark:bg-gray-400',
    black: 'bg-gray-800 dark:bg-gray-600'
  }
  return colorClasses[props.color] || 'bg-primary-500 dark:bg-primary-400'
})

const onImageError = () => {
  showImage.value = false
}

onMounted(() => {
  setTimeout(() => {
    animatedLevel.value = props.level
  }, 300)
})
</script> 